export const SELECTED_PLAN = 'selected_plan';
export const MODULE_ID = 'b2b_online_acq_dedicated';
export const AUTHORIZATION_HEADER = 'Authorization';
export const PNQ_AUTHORIZATION_HEADER = 'PnqAuthorization';
export const AUTHORIZATION_NEW_HEADER = 'NewAuthorization';
export const CUSTOMER_DETAIL = 'customer_detail';
export const DEDICATED_CUSTOMER_DETAIL = 'dedicated_customer_detail';
export const INSTALLATION_PAGE_CUSTOMER_DETAIL = 'installation_customer';
export const DEDICATED_INSTALLATION_PAGE_CUSTOMER_DETAIL = 'dedicated_installation_customer';
export const FEASIBILITY_DATA = 'feasibilityData';
export const DEDICATED_FEASIBILITY_DATA = 'dedicated_feasibilityData';
export const FEASIBILITY_RESPONSE = 'feasibilityResponse';
export const DEDICATED_FEASIBILITY_RESPONSE = 'dedicated_feasibilityResponse';
export const AUTHORIZED_SIGNATORY = 'authorizedSignatory';
export const ROUTER_LISTS = 'routerLists';
export const SUMMARY_AUTHORIZATION_HEADER = 'summary_authorization';
export const AVAILABLE_BANDWIDTH = 'available_bandwidth';
export const SELECTED_PARTY_ACCOUNT = 'selected_party_account';
export const SELECTED_PARTY_DATA = 'selected_party_data';
export const PROFILE_DATA = 'ProfileData';
export const UNAUTH_ACTIVE_STEP = 'unauth_active_step';
export const CONSTANTDATA = {
  SET_LIMIT_10: 10
};

export const JOURNEY_STEPS = ['Check Network Availability', 'Select Plan & Configuration', 'Confirm Order Details'];

export const JOURNEY_STEPS_INDEX = {
  CHECK_AVAILABLITY: 1,
  CHOOSE_PLAN: 2,
  BOOKING_SUMMARY: 3
};

export const JOURNEY_STEPS_FOR_MULTI_SITE = ['Check Network Availability', 'Select Plan & Configuration', 'Confirm Order Details'];

// export const UNAUTH_DEDICATED_JOURNEY_STEPS = ['Check Network Availability   ', 'Get a Customized Quotation'];
// new ILL Redesign Unauth steps
export const UNAUTH_DEDICATED_JOURNEY_STEPS = ['Customer Details   ', 'Installation Address'];

export const UNAUTH_DEDICATED_STEPS_INDEX = {
  'Check Availability': 1,
  Get_QUOTATION: 2
};

export const FEASIBILITY_STATUS = {
  FEASIBLE_HIGH_CONFIDENCE: { key: 'FEASIBLE', value: 'Excellent Network Area' },
  FEASIBLE_LOW_CONFIDENCE: { key: 'MANUAL_INTERVENTION_REQUIRED', value: 'Manual Network Check Required' },
  NOT_FEASIBLE_HIGH_CONFIDENCE: { key: 'NOT_FEASIBLE', value: 'No Network' },
  NOT_FEASIBLE_LOW_CONFIDENCE: { key: 'MANUAL_INTERVENTION_REQUIRED', value: 'Manual Network Check Required' }
};

export const SERVICES_ENUM = {
  MANAGED: 'MANAGED',
  UNMANAGED: 'UNMANAGED',
  PARTIALLY_MANAGED: 'PARTIALLY_MANAGED'
};

export const serviceOptions = [
  { id: '1', displayName: 'Managed Services', value: SERVICES_ENUM.MANAGED },
  { id: '2', displayName: 'Unmanaged Services', value: SERVICES_ENUM.UNMANAGED },
  { id: '3', displayName: 'Partially Managed', value: SERVICES_ENUM.PARTIALLY_MANAGED }
];

export const contractOptions = [
  { id: '1', displayName: '1 Year', value: 1, checked: true },
  { id: '2', displayName: '2 Years', value: 2 },
  { id: '3', displayName: '3 Years', value: 3 },
  { id: '4', displayName: '4 Years', value: 4 },
  { id: '5', displayName: '5 Years', value: 5 }
];
export const CAROUSEL_RESPONSIVE_CONSTANTS = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 3
  },
  tabletbig: {
    breakpoint: { max: 1024, min: 767 },
    items: 2.7,
    slidesToSlide: 3
  },
  tabletsmall: {
    breakpoint: { max: 768, min: 675 },
    items: 2.05,
    slidesToSlide: 2
  },
  mobilebig: {
    breakpoint: { max: 674, min: 426 },
    items: 2,
    slidesToSlide: 2
  },
  mobile: {
    breakpoint: { max: 425, min: 0 },
    items: 1,
    slidesToSlide: 1,
    partialVisibilityGutter: 50
  }
};
export const NOTIFICATION_TIMEOUT = 10;
export const SELECT_POP_UP = 'selectPopUp';
export const KNOW_MORE_POP_UP = 'knowMorePopUp';
export const DEFAULT_1_MONTH_PLAN = '1';
export const INITIATE_FETCHING = 'fetch data';
export const FETCH_SUCCESS = 'fetch data successfully';
export const FETCH_ERROR = 'error in fetching data';
export const HTTP_ERR_CODE = 'error code';
export const CUSTOMER_EMAIL = 'email';
export const CUSTOMER_PHONENUMER = 'phoneNumber';
export const CUSTOMER_NAME = 'customerName';
export const CUSTOMER_COMPANY_NAME = 'companyName';
export const CUSTOMER_OTP_SUCCESS = 'otpSuccess';
export const CUSTOMER_UNIQUEID = 'uniqueId';
export const LEAD_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  SUBMITTED: 'SUBMITTED',
  FEASIBILITY_PENDING: 'FEASIBILITY_PENDING',
  FEASIBILITY_COMPLETED: 'FEASIBILITY_COMPLETED',
  PNQ_IN_PROGRESS: 'PNQ_IN_PROGRESS',
  PNQ_COMPLETED: 'PNQ_COMPLETED',
  PNQ_CANCELED: 'PNQ_CANCELED',
  REJECTED: 'REJECTED',
  MANUAL_INTERVENTION_REQUIRED: 'MANUAL_INTERVENTION_REQUIRED',
  LEAD_SUBMITTED: 'LEAD_SUBMITTED',
  PRICING_APPROVAL_REQUEST_SENT: 'PRICING_APPROVAL_REQUEST_SENT',
  REQUIRED_PRICE_NEGOTIATION: 'REQUIRED_PRICE_NEGOTIATION',
  PRICING_DOA_REJECTED: 'PRICING_DOA_REJECTED',
  LEAD_CANCELED: 'LEAD_CANCELED',
  KYC_COMPLETED: 'KYC_COMPLETED',
  ORDER_IN_PROGRESS: 'ORDER_IN_PROGRESS',
  SEND_TO_DOA: 'SEND_TO_DOA',
  PRICING_DOA_APPROVED: 'PRICING_DOA_APPROVED'
};
export const LEAD_STATUS_MSG = {
  FEASIBILITY_PENDING: 'Our team will contact you within 24hrs for manual network check. For any query, please write to us at airtelforbusiness@airtel.com.',
  MANUAL_INTERVENTION_REQUIRED: 'Our team will contact you within 24hrs for a manual network check. However, choose a plan available in your location and save the order.',
  //KAM_MG:'You will be shortly contacted by your Key Account Manager regarding plans and pricing. Revised price (if any) shall be updated soon.',
  KAM_MG: 'Pricing for sites with non-standard IP/Hardware/Bandwidth is under review. Your Account Manager will soon update you on the same.',
  SENT_DOA_REQUEST_MSG: 'Your request has been sent successfully for approval as per DOA.',
  PNQ_COMPLETED_MSG_CUSTOMER: 'We are pleased to share the customized quote as per your requirements.',
  CLARITY_REQUIRED_MSG: 'Request has been sent back to you for clarity.'
};
export const POPUP_DATA = {
  AUTO_APPROVED_TITLE: 'Thank You!',
  AUTO_APPROVED_MSG: 'Price Auto Approved',
  AUTO_APPROVED_BTN_TXT: 'Ok Got It!'
};
export const PROCEED_CONFIRMATION = {
  CONFIRMATION_TITLE: 'Proceed to Booking Summary',
  CONFIRMATION_MSG: 'Please note that there will be no change in order after proceeding to the next step. Are you sure you want to proceed?',
  NOTICE_TITLE: 'Notice',
  NOTICE_MSG:
    'Please note that the selected plan with non-standard IP attributes/Hardware/Bandwidth will be submitted to the account manager for the pricing review. You will be notified with the finalised pricing within 24hrs. Do you want to proceed with this plan?'
};
export const ATTRIBUTE_TEXT = {
  STANDARD: 'Standard IP',
  NON_STANDARD: 'Non-Standard IP*'
};
export const PRODUCT_LIST = {
  VPN: 'Buy a VPN Plan',
  DEDICATED_INTERNET: 'Buy a Dedicated Internet Plan',
  NLD: 'Buy NLD (Direct VPN)',
  LL: 'Buy LL (Local Loop)',
  BULK_UPGRADE: {
    VPN: 'Upgrade VPN (MPLS) Circuits',
    DEDICATED_INTERNET: 'Upgrade Dedicated Internet (ILL) Circuits'
  }
};

export const serviceHardwareOptions = [
  { id: '1', displayName: 'Standard', value: 'STANDARD' },
  { id: '2', displayName: 'Non-Standard', value: 'NON_STANDARD' }
];
export const BANDWIDTH_LIST = [
  { value: '2', key: '2 Mbps' },
  { value: '4', key: '4 Mbps' },
  { value: '5', key: '5 Mbps' },
  { value: '6', key: '6 Mbps' },
  { value: '8', key: '8 Mbps' },
  { value: '10', key: '10 Mbps' },
  { value: '12', key: '12 Mbps' },
  { value: '15', key: '15 Mbps' },
  { value: '20', key: '20 Mbps' },
  { value: '25', key: '25 Mbps' },
  { value: '30', key: '30 Mbps' },
  { value: '35', key: '35 Mbps' },
  { value: '40', key: '40 Mbps' },
  { value: '45', key: '45 Mbps' },
  { value: ' 50', key: '50 Mbps' },
  { value: '60', key: '60 Mbps' },
  { value: '70', key: '70 Mbps' },
  { value: '80', key: '80 Mbps' },
  { value: '90', key: '90 Mbps' },
  { value: '100', key: '100 Mbps' },
  { value: '155', key: '155 Mbps' },
  { value: '200', key: '200 Mbps' },
  { value: '250', key: '250 Mbps' },
  { value: '300', key: '300 Mbps' },
  { value: '350', key: '350 Mbps' },
  { value: '400', key: '400 Mbps' },
  { value: '450', key: '450 Mbps' },
  { value: '475', key: '475 Mbps' },
  { value: '500', key: '500 Mbps' },
  { value: '600', key: '600 Mbps' },
  { value: '700', key: '700 Mbps' },
  { value: '800', key: '800 Mbps' },
  { value: '900', key: '900 Mbps' },
  { value: '1000', key: '1000 Mbps' },
  { value: '2000', key: '2000 Mbps' }
];
export const planListAboveText = 'Company agreed rates are displayed in the plans below. Please select a plan and contract period to proceed.';
export const planListAboveTextAfterDOA = 'Company agreed rates are displayed in the plans below.';
export const CAPEX_MEDIA_TYPE = {
  offnet: 'Offnet',
  thirdParty: 'Third Party'
};

export const mapToBandWidthList = (list = []) => {
  return list.map((value) => {
    return { value, key: `${value} Mbps` };
  });
};
export const DEFAULT_FEASIBILITY_DATA = {
  addressObj: {
    addressString: '',
    city: ''
  }
};
export const INVALID_API_RESPONSES = {
  INVALID_TOKEN: 'Invalid authorization token',
  MISSING_TOKEN: 'Authorization token missing from request header'
};

export const FEASIBILITY_STATUS_UNAUTH = {
  FEASIBLE: 'FEASIBLE'
};
